import { createFileRoute } from '@tanstack/react-router'
import { CreateAccount } from '@/features/tools/CreateAccount'

export const Route = createFileRoute('/_app/tools/create-account')({
  component: CreateAccount,
})
